<template>
    <component
      :is="componentType"
      :to="to"
      :href="href"
      :type="to || href ? undefined : type"
      class="base-button"
      :class="[
        `base-button--${variant}`,
        `base-button--${size}`,
        {
          'base-button--disabled': disabled
        }
      ]"
      :disabled="!to && !href ? disabled : undefined"
    >
      <slot />
    </component>
  </template>
  
  <script>
  export default {
    name: 'BaseButton',
  
    props: {
      to: {
        type: [String, Object],
        default: null
      },
  
      href: {
        type: String,
        default: null
      },
  
      type: {
        type: String,
        default: 'button'
      },
  
      variant: {
        type: String,
        default: 'primary'
      },
  
      size: {
        type: String,
        default: 'md'
      },
  
      disabled: {
        type: Boolean,
        default: false
      }
    },
  
    computed: {
      componentType() {
        if (this.to) {
          return 'RouterLink'
        }
  
        if (this.href) {
          return 'a'
        }
  
        return 'button'
      }
    }
  }
  </script>